module.exports = __webpack_public_path__ + "static/MuseoSans-500-8e19b825f8fea91317c27e3e9d629501.woff";